<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="dimensions"
    :height="dimensions"
    viewBox="0 0 20 20"
    :aria-labelledby="icon"
    role="presentation"
  >
    <title :id="icon" lang="en" v-if="title">{{ title }}</title>
    <title :id="icon" lang="en" v-else>{{ icon }} icon</title>
    <g :fill="currentColor" fill-rule="nonzero" :style="`transform: rotate(${rotation}); transform-origin: center;`">
      <Cog v-if="icon === 'cog'" :color="currentColor" />
      <Archive v-if="icon === 'archive'" :color="currentColor" />
      <ArrowRight v-if="icon === 'arrow-right'" :color="currentColor" />
      <Amazon v-if="icon === 'amazon'" :color="currentColor" />
      <Google v-if="icon === 'google'" :color="currentColor" />
      <Tf1 v-if="icon === 'tf1'" :color="currentColor" />
      <Teads v-if="icon === 'teads'" :color="currentColor" />
      <AudioOff v-if="icon === 'audio-off'" :color="currentColor" />
      <AudioOn v-if="icon === 'audio-on'" :color="currentColor" />
      <Calendar v-if="icon === 'calendar'" :color="currentColor" />
      <Check v-if="icon === 'check'" :color="currentColor" />
      <ChevronDown v-if="icon === 'chevron-down'" :color="currentColor" />
      <Disk v-if="icon === 'disk'" :color="currentColor" />
      <Eye v-if="icon === 'eye'" :color="currentColor" />
      <Facebook v-if="icon === 'facebook'" :color="currentColor" />
      <Hand v-if="icon === 'hand'" :color="currentColor" />
      <Iphone v-if="icon === 'iphone'" :color="currentColor" />
      <Link v-if="icon === 'link'" :color="currentColor" />
      <Lock v-if="icon === 'lock'" :color="currentColor" />
      <InfoRounded v-if="icon === 'info-rounded'" :color="currentColor" />
      <Instagram v-if="icon === 'instagram'" :color="currentColor" />
      <MagicWand v-if="icon === 'magic-wand'" :color="currentColor" />
      <Magnifier v-if="icon === 'magnifier'" :color="currentColor" />
      <Pause v-if="icon === 'pause'" :color="currentColor" />
      <Pen v-if="icon === 'pen'" :color="currentColor" />
      <Play v-if="icon === 'play'" :color="currentColor" />
      <Plus v-if="icon === 'plus'" :color="currentColor" />
      <Pinterest v-if="icon === 'pinterest'" :color="currentColor" />
      <Refresh v-if="icon === 'refresh'" :color="currentColor" />
      <Rocket v-if="icon === 'rocket'" :color="currentColor" />
      <Save v-if="icon === 'save'" :color="currentColor" />
      <Snapshat v-if="icon === 'snapchat'" :color="currentColor" />
      <TikTok v-if="icon === 'tiktok' || icon == 'tik-tok'" :color="currentColor" />
      <Time v-if="icon === 'time'" :color="currentColor" />
      <Trash v-if="icon === 'trash'" :color="currentColor" />
      <Videocam v-if="icon === 'videocam'" :color="currentColor" />
      <YouTube v-if="icon === 'youtube'" :color="currentColor" />
      <XMark v-if="icon === 'xmark'" :color="currentColor" />
    </g>
  </svg>
</template>

<script>
import Cog from './icons/Cog.vue';
import Archive from './icons/Archive.vue';
import Google from './icons/Google.vue';
import ArrowRight from './icons/arrow-right.vue';
import Teads from './icons/Teads.vue';
import Tf1 from './icons/Tf1.vue';
import Amazon from './icons/Amazon.vue';
import AudioOff from './icons/AudioOff.vue';
import AudioOn from './icons/AudioOn.vue';
import Calendar from './icons/Calendar.vue';
import Check from './icons/Check.vue';
import ChevronDown from './icons/ChevronDown.vue';
import Disk from './icons/Disk.vue';
import Eye from './icons/Eye.vue';
import Facebook from './icons/Facebook.vue';
import Hand from './icons/Hand.vue';
import Iphone from './icons/Iphone.vue';
import Link from './icons/Link.vue';
import Lock from './icons/Lock.vue';
import InfoRounded from './icons/InfoRounded.vue';
import Instagram from './icons/Instagram.vue';
import MagicWand from './icons/MagicWand.vue';
import Magnifier from './icons/Magnifier.vue';
import Pause from './icons/Pause.vue';
import Pen from './icons/Pen.vue';
import Play from './icons/Play.vue';
import Plus from './icons/Plus.vue';
import Pinterest from './icons/Pinterest.vue';
import Refresh from './icons/Refresh.vue';
import Rocket from './icons/Rocket.vue';
import Save from './icons/Save.vue';
import Snapshat from './icons/Snapchat.vue';
import TikTok from './icons/TikTok.vue';
import Time from './icons/Time.vue';
import Trash from './icons/Trash.vue';
import Videocam from './icons/Videocam.vue';
import YouTube from './icons/YouTube.vue';
import XMark from './icons/XMark.vue';

export default {
  name: 'TsIcon',
  components: {
    Cog,
    Archive,
    Amazon,
    Google,
    ArrowRight,
    Teads,
    Tf1,
    AudioOff,
    AudioOn,
    Calendar,
    Check,
    ChevronDown,
    Disk,
    Eye,
    Facebook,
    Hand,
    Iphone,
    Link,
    Lock,
    InfoRounded,
    Instagram,
    MagicWand,
    Magnifier,
    Pause,
    Pen,
    Play,
    Plus,
    Pinterest,
    Refresh,
    Rocket,
    Save,
    Snapshat,
    TikTok,
    Time,
    Trash,
    YouTube,
    Videocam,
    XMark
  },
  props: {
    pending: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    color: {
      type: String,
      default: '#000000'
    },
    rotation: {
      type: String,
      default: '0'
    }
  },
  computed: {
    currentColor() {
      return this.pending ? '#acbacc' : this.color;
    },
    dimensions() {
      switch (this.size) {
        case 'xxx-small':
          return '10px';
        case 'xx-small':
          return '12px';
        case 'x-small':
          return '16px';
        case 'small':
          return '20px';
        case 'large':
          return '28px';
        case 'medium':
        default:
          return '24px';
      }
    }
  }
};
</script>
